$(document).ready(function(){

  if($(".header-item").hasClass("rm-after-min")){
  	$(".header-item").animate({opacity: "1"},125,"linear");
  }
  // $('.cart__product-qty').removeAttr('max');
  // $('.cart__product-qty').removeAttr('min');
  // $('.cart__product-qty').attr('min', '1');
  // $('.cart__product-qty').removeAttr('readonly');
  
//   disabling the right click & F12 on the window
  $(document).on("contextmenu", "body", function(e) {
  	return false;
  });
  $("img").on("dragstart", function(e) {
  	e.preventDefault();
  });
  document.onkeypress = function (event) {  
    event = (event || window.event);  
    if (event.keyCode == 123) {  
    	return false;  
    }  
  }  
  document.onmousedown = function (event) {  
    event = (event || window.event);  
    if (event.keyCode == 123) {  
  		return false;  
    }  
  }  
  document.onkeydown = function (event) {  
    event = (event || window.event);  
    if (event.keyCode == 123) {  
  		return false;  
    }  
  }  
  
  $(".custom-slider").each(function(){
    
		var num_slides = $(this).data('slides');
    	var center_mode = $(this).data('center');
    	if (num_slides > 3){
    		var tab_num_slides = 3;
    		var mob_num_slides = 2;
    	}
    	else if (num_slides > 2){
    		var tab_num_slides = 2;
    		var mob_num_slides = 1;
    	}
    	else{
    		var tab_num_slides = 1;
    		var mob_num_slides = 1;
    	}
    
    	$(this).slick({
          autoplay:true,
          autoplaySpeed:5000,
          speed:600,
          slidesToShow: num_slides,
          slidesToScroll:1,
          dots:false,
          arrows: true,
          draggable:true,
		  centerMode: false,
          nextArrow: '<i class="fa fa-arrow-right"></i>',
  		  prevArrow: '<i class="fa fa-arrow-left"></i>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: tab_num_slides
              }
            },
            {
              breakpoint: 576,
              settings: {
		  		centerMode: center_mode,
                slidesToShow: mob_num_slides
              }
            }
          ]
        });
	});

});